import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import {
  getGamificationProfileSelector,
  getLeaderboardSelector,
  getWeeklyBadgesSelector,
} from '../../shared/reducers/gamification-selectors';
import { AppState } from '../../shared/reducers/index.tx';
import { GamificationBadgeDto } from '../../shared/types/GamificationBadgeDto';
import { GamificationLeaderboardDto } from '../../shared/types/GamificationLeaderboardDto';
import { GamificationLeagueDto } from '../../shared/types/GamificationLeagueDto';
import { GamificationProfileDto } from '../../shared/types/GamificationProfileDto';
import { GamificationSettingsDto } from '../../shared/types/GamificationSettingsDto';
import { LeaderboardStatusType } from '../../shared/types/leaderboard-status-type';

@Component({
  selector: 'lp2-progress-page-leaderboards',
  templateUrl: './progress-page-leaderboards.component.html',
  styleUrls: ['./progress-page-leaderboards.component.scss', '../progress-page/progress-page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressPageLeaderboardsComponent implements OnInit, OnDestroy {
  @Input() leagues: GamificationLeagueDto[];
  @Input() gamificationSettings: GamificationSettingsDto;
  @Input() leaderboardStatus: LeaderboardStatusType;
  gamificationProfile$: Observable<GamificationProfileDto>;
  activityBadge$: Observable<GamificationBadgeDto>;
  leaderboardData$: Observable<GamificationLeaderboardDto>;

  leaderboardStatusType = LeaderboardStatusType;
  destroy = new Subject<boolean>();

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    this.leaderboardData$ = this.store.pipe(select(getLeaderboardSelector), takeUntil(this.destroy));
    this.gamificationProfile$ = this.store.pipe(select(getGamificationProfileSelector), takeUntil(this.destroy));
    this.activityBadge$ = this.store.pipe(
      select(getWeeklyBadgesSelector),
      takeUntil(this.destroy),
      map((data: GamificationBadgeDto[]) => (data ? data[0] : null))
    );
  }

  ngOnDestroy(): void {
    this.destroy.next(true);
    this.destroy.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./ts/app/progress/progress-page-leaderboards/progress-page-leaderboards.component.ts